import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EPagesPath } from '../../app.routes';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService {
  private excludedRoutes: string[] = [EPagesPath.contentManagement, EPagesPath.archive];
  private currentUrl = new BehaviorSubject<string>('');

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentUrl.next(event.urlAfterRedirects);
    });
  }

  shouldShowComponent(): boolean {
    const currentRoute = this.currentUrl.value;
    return !this.excludedRoutes.some(route => currentRoute.includes(route));
  }
}
